import app from 'apprun';

interface PasswordInputProps {
  id: string;
  name?: string;
  class?: string;
  placeholder?: string;
  required?: boolean;
  autocomplete?: string;
  value?: string;
  size?: number;
  maxlength?: number;
  label?: string;
  disabled?: boolean;
  oninput?: (e: Event) => void;
  onchange?: (e: Event) => void;
  onblur?: (e: Event) => void;
  onfocus?: (e: Event) => void;
  onkeypress?: (e: Event) => void;
  onkeyup?: (e: Event) => void;
  style?: any;
}

export const PasswordInput = ({
  id,
  name,
  class: className = 'form-control',
  placeholder,
  required,
  autocomplete,
  value,
  size,
  maxlength,
  label,
  disabled,
  oninput,
  onchange,
  onblur,
  onfocus,
  onkeypress,
  onkeyup,
  style,
  ...otherProps
}: PasswordInputProps) => {

  const togglePassword = (inputId: string) => {
    const passwordInput = document.getElementById(inputId) as HTMLInputElement;
    const toggleIcon = document.getElementById(`${inputId}_toggle_icon`) as HTMLElement;

    if (passwordInput && toggleIcon) {
      if (passwordInput.type === 'password') {
        passwordInput.type = 'text';
        toggleIcon.classList.remove('fa-eye');
        toggleIcon.classList.add('fa-eye-slash');
      } else {
        passwordInput.type = 'password';
        toggleIcon.classList.remove('fa-eye-slash');
        toggleIcon.classList.add('fa-eye');
      }
    }
  };

  // Define layout classes that should be moved to the wrapper
  const layoutClasses = ['pull-right', 'pull-left', 'float-right', 'float-left'];

  // Split className into layout and styling classes
  const classNames = className ? className.split(' ') : [];
  const wrapperClasses = classNames.filter(cls => layoutClasses.includes(cls));
  const inputClasses = classNames.filter(cls => !layoutClasses.includes(cls));

  // Determine if we have layout classes that affect positioning
  const hasLayoutClass = wrapperClasses.length > 0;

  const containerStyle = {
    position: 'relative',
    display: 'inline-block',
    // Only use 100% width if no layout classes are present
    width: hasLayoutClass ? 'auto' : '100%',
    ...style
  };

  const inputStyle = {
    paddingRight: '35px'
  };

  const iconStyle = {
    position: 'absolute',
    right: '10px',
    top: '50%',
    transform: 'translateY(-50%)',
    cursor: 'pointer',
    color: '#6c757d',
    zIndex: 10
  };

  return (
    <div class={wrapperClasses.join(' ')} style={containerStyle}>
      <input
        id={id}
        name={name || id}
        type="password"
        class={inputClasses.join(' ') || undefined}
        placeholder={placeholder || ''}
        required={required}
        autocomplete={autocomplete}
        {...(value !== undefined ? { value } : {})}
        {...(size && size > 0 ? { size } : {})}
        maxlength={maxlength}
        label={label}
        disabled={disabled}
        oninput={oninput}
        onchange={onchange}
        onblur={onblur}
        onfocus={onfocus}
        onkeypress={onkeypress}
        onkeyup={onkeyup}
        style={inputStyle}
        {...otherProps}
      />
      <i
        id={`${id}_toggle_icon`}
        class="fa fa-eye"
        style={iconStyle}
        onclick={() => togglePassword(id)}
        title="Show/Hide Password"
        aria-label="Toggle password visibility"
      />
    </div>
  );
};

export default PasswordInput;
